var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-nav',_vm._l((_vm.menu),function(route,index){return _c('li',{key:index,staticClass:"list-inline-item"},[_c('menuItem',{key:'itemIndex' + index,attrs:{"route":route}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }